__turbopack_context__.v({
  "eyebrow": "product-page-sections-module__qgy3zW__eyebrow",
  "faqButton": "product-page-sections-module__qgy3zW__faqButton",
  "faqButtonIcon": "product-page-sections-module__qgy3zW__faqButtonIcon",
  "faqButtonLabel": "product-page-sections-module__qgy3zW__faqButtonLabel",
  "faqChevron": "product-page-sections-module__qgy3zW__faqChevron",
  "faqChevronOpen": "product-page-sections-module__qgy3zW__faqChevronOpen",
  "faqContent": "product-page-sections-module__qgy3zW__faqContent",
  "faqHeader": "product-page-sections-module__qgy3zW__faqHeader",
  "faqIcon": "product-page-sections-module__qgy3zW__faqIcon",
  "faqImage": "product-page-sections-module__qgy3zW__faqImage",
  "faqInner": "product-page-sections-module__qgy3zW__faqInner",
  "faqItem": "product-page-sections-module__qgy3zW__faqItem",
  "faqList": "product-page-sections-module__qgy3zW__faqList",
  "faqMedia": "product-page-sections-module__qgy3zW__faqMedia",
  "faqMediaAsset": "product-page-sections-module__qgy3zW__faqMediaAsset",
  "faqPanel": "product-page-sections-module__qgy3zW__faqPanel",
  "faqPanelInner": "product-page-sections-module__qgy3zW__faqPanelInner",
  "faqSection": "product-page-sections-module__qgy3zW__faqSection",
  "faqSubtitle": "product-page-sections-module__qgy3zW__faqSubtitle",
  "faqTitle": "product-page-sections-module__qgy3zW__faqTitle",
  "faqTrigger": "product-page-sections-module__qgy3zW__faqTrigger",
  "featureColumns": "product-page-sections-module__qgy3zW__featureColumns",
  "featureCopy": "product-page-sections-module__qgy3zW__featureCopy",
  "featureLayout": "product-page-sections-module__qgy3zW__featureLayout",
  "featureMedia": "product-page-sections-module__qgy3zW__featureMedia",
  "featureMediaAsset": "product-page-sections-module__qgy3zW__featureMediaAsset",
  "featuredReviewBody": "product-page-sections-module__qgy3zW__featuredReviewBody",
  "featuredReviewCard": "product-page-sections-module__qgy3zW__featuredReviewCard",
  "featuredReviewContent": "product-page-sections-module__qgy3zW__featuredReviewContent",
  "featuredReviewMedia": "product-page-sections-module__qgy3zW__featuredReviewMedia",
  "featuredReviewMeta": "product-page-sections-module__qgy3zW__featuredReviewMeta",
  "featuredReviewStars": "product-page-sections-module__qgy3zW__featuredReviewStars",
  "featuredReviews": "product-page-sections-module__qgy3zW__featuredReviews",
  "linkAction": "product-page-sections-module__qgy3zW__linkAction",
  "merchantReply": "product-page-sections-module__qgy3zW__merchantReply",
  "ownerReviewCard": "product-page-sections-module__qgy3zW__ownerReviewCard",
  "ownerReviewComment": "product-page-sections-module__qgy3zW__ownerReviewComment",
  "ownerReviewDot": "product-page-sections-module__qgy3zW__ownerReviewDot",
  "ownerReviewImage": "product-page-sections-module__qgy3zW__ownerReviewImage",
  "ownerReviewMedia": "product-page-sections-module__qgy3zW__ownerReviewMedia",
  "ownerReviewMeta": "product-page-sections-module__qgy3zW__ownerReviewMeta",
  "ownerReviewName": "product-page-sections-module__qgy3zW__ownerReviewName",
  "ownerReviewNavButton": "product-page-sections-module__qgy3zW__ownerReviewNavButton",
  "ownerReviewRating": "product-page-sections-module__qgy3zW__ownerReviewRating",
  "ownerReviewStarActive": "product-page-sections-module__qgy3zW__ownerReviewStarActive",
  "ownerReviewStarMuted": "product-page-sections-module__qgy3zW__ownerReviewStarMuted",
  "ownerReviewTag": "product-page-sections-module__qgy3zW__ownerReviewTag",
  "ownerReviewTags": "product-page-sections-module__qgy3zW__ownerReviewTags",
  "ownerReviewVerified": "product-page-sections-module__qgy3zW__ownerReviewVerified",
  "ownerReviewVerifiedIcon": "product-page-sections-module__qgy3zW__ownerReviewVerifiedIcon",
  "ownerReviewsButton": "product-page-sections-module__qgy3zW__ownerReviewsButton",
  "ownerReviewsButtonContent": "product-page-sections-module__qgy3zW__ownerReviewsButtonContent",
  "ownerReviewsButtonIcon": "product-page-sections-module__qgy3zW__ownerReviewsButtonIcon",
  "ownerReviewsButtonLabel": "product-page-sections-module__qgy3zW__ownerReviewsButtonLabel",
  "ownerReviewsHeader": "product-page-sections-module__qgy3zW__ownerReviewsHeader",
  "ownerReviewsInner": "product-page-sections-module__qgy3zW__ownerReviewsInner",
  "ownerReviewsNav": "product-page-sections-module__qgy3zW__ownerReviewsNav",
  "ownerReviewsNavButton": "product-page-sections-module__qgy3zW__ownerReviewsNavButton",
  "ownerReviewsSection": "product-page-sections-module__qgy3zW__ownerReviewsSection",
  "ownerReviewsSliderShell": "product-page-sections-module__qgy3zW__ownerReviewsSliderShell",
  "ownerReviewsSubtitle": "product-page-sections-module__qgy3zW__ownerReviewsSubtitle",
  "ownerReviewsTitle": "product-page-sections-module__qgy3zW__ownerReviewsTitle",
  "ownerReviewsTrack": "product-page-sections-module__qgy3zW__ownerReviewsTrack",
  "ownerReviewsViewport": "product-page-sections-module__qgy3zW__ownerReviewsViewport",
  "primaryAction": "product-page-sections-module__qgy3zW__primaryAction",
  "problemCard": "product-page-sections-module__qgy3zW__problemCard",
  "problemHero": "product-page-sections-module__qgy3zW__problemHero",
  "problemHeroCard": "product-page-sections-module__qgy3zW__problemHeroCard",
  "problemHeroCardBody": "product-page-sections-module__qgy3zW__problemHeroCardBody",
  "problemHeroCardDescription": "product-page-sections-module__qgy3zW__problemHeroCardDescription",
  "problemHeroCardTitle": "product-page-sections-module__qgy3zW__problemHeroCardTitle",
  "problemHeroCards": "product-page-sections-module__qgy3zW__problemHeroCards",
  "problemHeroContent": "product-page-sections-module__qgy3zW__problemHeroContent",
  "problemHeroHeader": "product-page-sections-module__qgy3zW__problemHeroHeader",
  "problemHeroIconWrap": "product-page-sections-module__qgy3zW__problemHeroIconWrap",
  "problemHeroInner": "product-page-sections-module__qgy3zW__problemHeroInner",
  "problemHeroScrim": "product-page-sections-module__qgy3zW__problemHeroScrim",
  "problemHeroSection": "product-page-sections-module__qgy3zW__problemHeroSection",
  "problemHeroSubtitle": "product-page-sections-module__qgy3zW__problemHeroSubtitle",
  "problemHeroTitle": "product-page-sections-module__qgy3zW__problemHeroTitle",
  "problemSection": "product-page-sections-module__qgy3zW__problemSection",
  "reviewTag": "product-page-sections-module__qgy3zW__reviewTag",
  "reviewTrack": "product-page-sections-module__qgy3zW__reviewTrack",
  "reviewViewport": "product-page-sections-module__qgy3zW__reviewViewport",
  "richText": "product-page-sections-module__qgy3zW__richText",
  "sectionHeader": "product-page-sections-module__qgy3zW__sectionHeader",
  "sliderArrow": "product-page-sections-module__qgy3zW__sliderArrow",
  "sliderDot": "product-page-sections-module__qgy3zW__sliderDot",
  "sliderDotActive": "product-page-sections-module__qgy3zW__sliderDotActive",
  "sliderDots": "product-page-sections-module__qgy3zW__sliderDots",
  "sliderNavigation": "product-page-sections-module__qgy3zW__sliderNavigation",
  "timelineButton": "product-page-sections-module__qgy3zW__timelineButton",
  "timelineButtonIcon": "product-page-sections-module__qgy3zW__timelineButtonIcon",
  "timelineButtonLabel": "product-page-sections-module__qgy3zW__timelineButtonLabel",
  "timelineContent": "product-page-sections-module__qgy3zW__timelineContent",
  "timelineCopy": "product-page-sections-module__qgy3zW__timelineCopy",
  "timelineDescription": "product-page-sections-module__qgy3zW__timelineDescription",
  "timelineDot": "product-page-sections-module__qgy3zW__timelineDot",
  "timelineHeader": "product-page-sections-module__qgy3zW__timelineHeader",
  "timelineImage": "product-page-sections-module__qgy3zW__timelineImage",
  "timelineInner": "product-page-sections-module__qgy3zW__timelineInner",
  "timelineItem": "product-page-sections-module__qgy3zW__timelineItem",
  "timelineItemBody": "product-page-sections-module__qgy3zW__timelineItemBody",
  "timelineItemHeader": "product-page-sections-module__qgy3zW__timelineItemHeader",
  "timelineItemTitle": "product-page-sections-module__qgy3zW__timelineItemTitle",
  "timelineList": "product-page-sections-module__qgy3zW__timelineList",
  "timelineMedia": "product-page-sections-module__qgy3zW__timelineMedia",
  "timelinePeriod": "product-page-sections-module__qgy3zW__timelinePeriod",
  "timelineSection": "product-page-sections-module__qgy3zW__timelineSection",
  "timelineStep": "product-page-sections-module__qgy3zW__timelineStep",
  "timelineSubtitle": "product-page-sections-module__qgy3zW__timelineSubtitle",
  "timelineTag": "product-page-sections-module__qgy3zW__timelineTag",
  "timelineTitle": "product-page-sections-module__qgy3zW__timelineTitle",
  "videoFrame": "product-page-sections-module__qgy3zW__videoFrame",
  "videoPlayButton": "product-page-sections-module__qgy3zW__videoPlayButton",
  "videoSection": "product-page-sections-module__qgy3zW__videoSection",
  "videoSlide": "product-page-sections-module__qgy3zW__videoSlide",
  "videoTrack": "product-page-sections-module__qgy3zW__videoTrack",
  "videoViewport": "product-page-sections-module__qgy3zW__videoViewport",
});
